<template>
    <div v-if="posts && posts.length > 0" v-bind:class="cssListClass()">
        <h2 v-if="heading" class="list__heading">{{ heading }}</h2>

        <div class="list__post" v-for="(post, index) in posts" v-bind:key="index">
            <router-link v-if="post.image" :to="post.uri" :style="{ 'background-image': 'url(' + post.image.url + ')' }" class="list__post__image">
                <img :src="post.image.url" :title="post.title" />
            </router-link>
            <div class="list__post__container">
                <div class="list__post__text">
                    <h2 class="list__post__heading">
                        <router-link :to="post.uri">{{ post.title }}</router-link>
                    </h2>
                    <div class="list__post__lead" v-html="post.lead"></div>
                </div>
                <div class="list__post__meta" v-if="direction == 'column'">
                    <div v-if="post.author" class="list__post__meta__author">
                        <label>Forfatter:</label>
                        <span>{{ post.author.name }}</span>
                    </div>
                    <div class="list__post__meta__pubdate">
                        <label>Publisert:</label>
                        <span>{{ post.postDate }}</span>
                    </div>
                </div>
                <router-link v-if="direction == 'column' && post.category" v-bind:class="cssPostCategoryClass(post)" :to="post.category.uri">
                    {{ post.category.name }}
                </router-link>
            </div>
        </div>

        <div v-if="button" class="list__button">
            <router-link :to="buttonTo">{{ button }}</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListPosts',
    props: {
        heading: {
            type: String,
        },
        posts: {
            type: Array,
            required: true,
        },
        direction: {
            type: String,
            default: 'column',
        },
        button: {
            type: String,
        },
        buttonTo: {
            type: String,
        },
    },
    methods: {
        cssListClass() {
            const cssClass = {
                list: true,
                list__posts: true,
            };
            cssClass['list__posts--' + this.direction] = true;
            return cssClass;
        },
        cssPostCategoryClass(post) {
            const cssClass = {
                list__post__category: true,
            };

            if (post.category && post.category.color) {
                cssClass['post__category--' + post.category.color] = true;
            }

            return cssClass;
        },
    },
};
</script>
